
export const merge = (baseDate: Date, datePart: Date, timePart: Date) => {
  
    if ( !datePart ){
      return undefined;
    }
        
    const d = baseDate;      
    const isValidDay = datePart && !isNaN(datePart.getTime());
    const isValidTime = timePart && !isNaN(timePart.getDate());

    if (isValidDay ){
      d.setTime(datePart.getTime());      
      d.setUTCHours(0, 0, 0, 0);
    }
    
    // set hours from time component, without affecting the selected date in case of crossing 24hrs timeline
    if (isValidTime){
        d.setUTCHours(timePart.getUTCHours());
        d.setUTCMinutes(timePart.getUTCMinutes());
    }
        
    return d;
  };
